import Base from '@/mixins/topologymap/base';
import { MapPopup } from '@/views/topologymap/js/maps';

export default {
  mixins: [Base],
  methods: {
    /**
     * 툴바 버튼 선택 상태와 팝업창 오픈 상태를 동기화한다.
     * @author KangBonghun(toto1323)
     * @param  {Component} win 팝업창 컴포넌트
     * @param  {Component} btn 툴바 버튼
     */
    toggleWindowButton(win, btn) {
      if (btn && btn.selected) {
        MapPopup.showPopup(win, {
          events: {
            hidden: () => {
              btn.selected = false;
            },
          },
        });
      } else {
        MapPopup.closeAndHide(win.name);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/topologymap/toolbar.js